const styles = (theme) => ({
  formContainer: {
    paddingLeft: 8,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: "4px",
    paddingRight: 8,
  },
  label: {
    minWidth: 90,
  },
  contactName: {
    margin: 0,
    maxWidth: 110,
    marginRight: 16,
  },
  comments: {
    margin: 0,
    width: "100%",
    marginRight: 16,
  },
  commentsLabel: {
    alignSelf: "flex-start",
    minWidth: 90,
    marginTop: 24,
  },
  timeInput: {
    marginTop: 16,
    marginBottom: 16,
    marginRight: 16,
  },
  inputFieldWrapper: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  commentsWrapper: {
    flexGrow: 1,
  },
});

export default styles;
